<template>
  <div class="header b_white">
    <div class="clear relative w1200 box110">
      <input type="hidden" id="isGoods" value="" />
      <h1 class="d_logo pull-left mar15_td">
        <a :href="`${app}`" class="pull-left clear relative">
          <img src="./images/logo.png" height="54px" width="149px" />
        </a>
        <span class="f24 isHave dl_span">卖家中心</span>
      </h1>
      <div class="f16 d_mjzx pull-left relative">
        <span class="dtxt"
          ><input type="hidden" class="twidth" /><em>{{ shop.name }}</em>
          <a href="javascript:" class="red f12 pad10_l d_qhdp" @click="switchoverShop">[切换店铺]</a></span
        >
        <div class="dm_menu border" id="shopLists" v-if="showShopList">
          <ul class="f14 dm_link">
            <li v-for="(item, index) in shopList" :key="index">
              <i v-if="item.isShopkeeper === 1" class="pad5_l bor_red red mar5_r f12 dm_bq">店主</i>
              <a class="inlineblock pad40_l" @click="selectShop(item)" :href="`${app}mj/toSetbacks.do?toSCType=1&changeShopId=${item.shopIds}`">{{
                item.name
              }}</a>
            </li>
            <li v-if="shopList && shopList.length <= 1">
              <div>没有其他店铺，如有需要</div>
              <a class="inlineblock pad40_l" :href="`${app}mj/toSetbacks.do?againShop=1`">新开一个店铺</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="h_navbox">
      <div class="h_nav w1200">
        <ul class="hrefList">
          <li class="hn_all">
            <a :href="`${app}goods/queryCategoryInfo.do`" class="f16 yahei all white"><i class="iconfont icon-fl vertical_m mar10_r"></i>全部货品分类</a>
          </li>
          <li class="cur">
            <a :href="`${app}husbandry/pc/breedIndex.do`" target="_blank" class="f16 yahei">养殖市场</a>
          </li>
          <li><a :href="`${app}husbandry/pc/nzScIndexNew.do`" target="_blank" class="f16 yahei">种植市场</a></li>
          <li><a :href="`${app}recommend/internetOfThings`" target="_blank" class="f16 yahei">智能设备</a></li>
          <li><a :href="`${app}husbandry/pc/ncpScIndexNew`" target="_blank" class="f16 yahei">农产品超市</a></li>
          <li><a href="https://www.gjszsc.com" target="_blank" class="f16 yahei">国家生猪市场</a></li>
          <li><a href="https://znt.com.cn/intelligent" target="_blank" class="f16 yahei">应用市场</a></li>
          <li>
            <a :href="`${app}goods/optimization/pc/optimizationPc.do`" class="f16 yahei" target="_blank">农信优选</a>
          </li>
          <li>
            <a :href="`${app}recommend/activity/216`" class="f16 yahei nxjc_b" target="_blank">农信集采</a>
          </li>
          <li><a href="https://www.huolianw.com/index.do" class="f16 yahei" target="_blank">农信货联</a></li>
          <li><a :href="`${app}goods/queryVipGoods.do`" target="_blank" class="f16 yahei">VIP商城</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      shop: {},
      shopList: [],
      showShopList: false,
      app: process.env.VUE_APP_APP,
      passport: process.env.VUE_APP_PASSPORT,
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  mounted() {
    this.$nextTick(() => {
      this.getHeader();
    });
  },
  methods: {
    switchoverShop() {
      this.showShopList = !this.showShopList;
    },
    selectShop(item) {
      this.$set(this.shop, "name", item.name);
    },
    getHeader() {
      this.$store.dispatch("header/getHeader", {}).then((data) => {
        if (!data) {
          return;
        }
        this.shop = data.shop || {};
        if (data.shopList && data.shopList.length > 0 && data.shop) {
          data.shopList.splice(
            data.shopList.findIndex((item) => item.shopIds === data.shop.shopIdStr),
            1
          );
        }
        this.shopList = data.shopList || [];
      });
    },
  },
};
</script>
